import { GlobalOutlined } from '@ant-design/icons';
import { localeNames, type Locale } from '@estimating/i18n';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../locale/locale-context';

export function LanguageSwitcher() {
  const { t } = useTranslation();
  const { locale, supportedLocales, setLocale } = useLocale();

  return (
    <Select<Locale>
      aria-label={t('language.label')}
      prefix={<GlobalOutlined aria-hidden />}
      value={locale}
      onChange={setLocale}
      options={supportedLocales.map((value) => ({ value, label: localeNames[value] }))}
      style={{ minWidth: 200 }}
    />
  );
}
